import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import auth from './modules/auth';
import chat from './modules/chat';
import knowledge from './modules/knowledge';
import notification from './modules/notification';
import tags from './modules/tags';
import urlMetadata from './modules/urlMetadata';

// Create vuex persistence for storing state in localStorage
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'mgmt-ui',
  modules: ['auth']
});

const store = createStore({
  modules: {
    auth,
    chat,
    knowledge,
    notification,
    tags,
    urlMetadata
  },
  plugins: [vuexLocal.plugin]
});

export default store;
